import {Reducer} from "react";
import {ErrorObject} from "../components/error/ErrorObject";
import {SetError, SetNotification} from "./CommonActions";

export interface StateProps {
  error?: ErrorObject;
  notification?: string;
}

export type ActionProps = SetError | SetNotification;

export const initialState: StateProps = {};

export const reducer: Reducer<StateProps, ActionProps> = (state, action) => {
  switch (action.type) {
    case "setError":
      return {
        ...state,
        error: action.payload,
      };
    case "setNotification":
      return {
        ...state,
        notification: action.payload,
      };
    default:
      throw new Error();
  }
}